
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/fuel-cost-calculator",
      function () {
        return require("private-next-pages/calculators/fuel-cost-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/fuel-cost-calculator"])
      });
    }
  